<template>
  <main class="page-operative page-operative-crisi-impresa">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between">
        <PageTitle class="mb-1">Prevenzione crisi d'impresa</PageTitle>
      </div>
      <div v-if="companyCategory">
        <OperativeTable class="report-texts-size" dense>
          <tbody>

          <OperativeTableSectionTitle :years="monthsTableHeadings">Indice sintetico</OperativeTableSectionTitle>
                  <OperativeTableBodyHeader :years="monthsTableHeadings" show-years>Indice sintetico</OperativeTableBodyHeader>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.sinteticoDSCRSign" v-if="DSCRsignificant">
            Indice sintetico con DSCR significativo
            <template #cell-content="{ value }">
              <Semaphore :value="value" :label="value | alarm" />
              {{ value | alarm }}
            </template>
          </OperativeTableBodyRow>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.sinteticoDSCRNonSign" v-else>
            Indice sintetico con DSCR non significativo
            <template #cell-content="{ value }">
              <Semaphore :value="value" :label="value | alarm" />
              {{ value | alarm }}
            </template>
          </OperativeTableBodyRow>

          <OperativeTableEmptyBodyRow :years="monthsTableHeadings" />

          <OperativeTableSectionTitle :years="monthsTableHeadings">Patrimonio netto</OperativeTableSectionTitle>
          <OperativeTableBodyHeader :years="monthsTableHeadings" show-years>Patrimonio netto</OperativeTableBodyHeader>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.patrimonioNetto">
            Patrimonio netto
            <template #cell-content="{ value }">{{ value | money }}</template>
          </OperativeTableBodyRow>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.patrimonioNettoCategory">
            Patrimonio netto category
            <template #cell-content="{ value }">
              <Semaphore :value="value" :label="value | alarm" />
              {{ value | alarm }}
            </template>
          </OperativeTableBodyRow>

          <OperativeTableEmptyBodyRow :years="monthsTableHeadings" />

          <OperativeTableSectionTitle :years="monthsTableHeadings">DSCR</OperativeTableSectionTitle>
            <BFormCheckbox align="left" v-model="DSCRsignificant" class="no-select " :switch="true">
              DSCR significativo
            </BFormCheckbox>
          <OperativeTableBodyHeader :years="monthsTableHeadings" show-years>DSCR</OperativeTableBodyHeader>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.DSCR">
            DSCR
            <template #cell-content="{ value }">{{ value | round }}</template>
          </OperativeTableBodyRow>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.DSCRCategory">
            DSCR category
            <template #cell-content="{ value }">
              <Semaphore :value="value" :label="value | alarm" />
              {{ value | alarm }}
            </template>
          </OperativeTableBodyRow>

          <OperativeTableEmptyBodyRow :years="monthsTableHeadings" />

          <OperativeTableSectionTitle :years="monthsTableHeadings">Indici settoriali</OperativeTableSectionTitle>
          <tr >
            <th class="mt-2" style="border: 0" :colspan="50">Codice ATECO: {{ companyCategory | category }}</th>
          </tr>
          <OperativeTableBodyHeader :years="monthsTableHeadings" show-years>Sintesi</OperativeTableBodyHeader>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.settoriali">
            Indici settoriali in alert
            <template #cell-content="{ value }">{{ value }}</template>
          </OperativeTableBodyRow>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.settorialiCategory">
            Indici settoriali Category
            <template #cell-content="{ value }">
              <Semaphore :value="value" :label="value | alarm" />
              {{ value | alarm }}
            </template>
          </OperativeTableBodyRow>
          <OperativeTableEmptyBodyRow :years="monthsTableHeadings"/>
          <OperativeTableBodyHeader :years="monthsTableHeadings" show-years>Sostenibilità oneri finanziari (%)</OperativeTableBodyHeader>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.sostenibilitaOneriFinanziari">
            Sostenibilità degli oneri finanziari
            <template #cell-content="{ value }">{{ value | round }}</template>
          </OperativeTableBodyRow>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.sostenibilitaOneriFinanziariAlert">
            Sostenibilità degli oneri finanziari alert
            <template #cell-content="{ value }">
              <Semaphore :value="value ? 1 : 4" />
            </template>
          </OperativeTableBodyRow>

          <OperativeTableBodyHeader :years="monthsTableHeadings" show-years>Adeguatezza patrimoniale (%)</OperativeTableBodyHeader>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.adeguatezzaPatrimoniale">
            Adeguatezza patrimoniale
            <template #cell-content="{ value }">{{ value | round }}</template>
          </OperativeTableBodyRow>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.adeguatezzaPatrimonialeAlert">
            Adeguatezza patrimoniale alert
            <template #cell-content="{ value }">
              <Semaphore :value="value ? 1 : 4" />
            </template>
          </OperativeTableBodyRow>

          <OperativeTableBodyHeader :years="monthsTableHeadings" show-years>Liquidità (%)</OperativeTableBodyHeader>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.liquidita">
            Liquidità
            <template #cell-content="{ value }">{{ value | round }}</template>
          </OperativeTableBodyRow>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.liquiditaAlert">
            Liquidità alert
            <template #cell-content="{ value }">
              <Semaphore :value="value ? 1 : 4"/>
            </template>
          </OperativeTableBodyRow>

          <OperativeTableBodyHeader :years="monthsTableHeadings" show-years>Ritorno Liquido Attivo (%)</OperativeTableBodyHeader>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.ritornoLiquidoAttivo">
            Ritorno Liquido Attivo
            <template #cell-content="{ value }">{{ value | round }}</template>
          </OperativeTableBodyRow>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.ritornoLiquidoAttivoAlert">
            Ritorno Liquido Attivo alert
            <template #cell-content="{ value }">
              <Semaphore :value="value ? 1 : 4" />
            </template>
          </OperativeTableBodyRow>

          <OperativeTableBodyHeader :years="monthsTableHeadings" show-years>Indebitamento Previdenziale e Tributario (%)</OperativeTableBodyHeader>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.indebitamentoPrevidenzialeTributario">
            Indebitamento Previdenziale e Tributario
            <template #cell-content="{ value }">{{ value | round }}</template>
          </OperativeTableBodyRow>
          <OperativeTableBodyRow align="left" :values="monthsTableRows.indebitamentoPrevidenzialeTributarioAlert">
            Indebitamento Previdenziale e Tributario alert
            <template #cell-content="{ value }">
              <Semaphore :value="value ? 1 : 4"/>
            </template>
          </OperativeTableBodyRow>

          </tbody>
        </OperativeTable>
      </div>
      <div v-else class="alert alert-info mt-4">
        <h1 class="h4 alert-heading">Attenzione</h1>
        <p>
          Per poter visualizzare la seguente sezione, è necessario impostare la categoria d'azienda nella sezione "impostazioni".
        </p>
        <hr>
        <button class="btn btn-primary" type="button" @click.prevent="$router.push({ name: 'operative-company.settings'})">Vai alle impostazioni</button>
      </div>
    </div>
  </main>
</template>

<script>

import { BFormCheckbox } from 'bootstrap-vue';
import operativePageMixin from '@/mixins/operativePage.js';
import loadingDataMixin from '@/mixins/loadingData.js';
import computedFinancialDataMixin from '@/mixins/computedFinancialData.js';
import formatMoney from '@/filters/formatMoney.js';
import formatAlertFilter from '@/filters/formatAlert';
import formatCompanyCategory from '@/filters/formatCompanyCategory';
import formatRoundFilter from '@/filters/formatRound';
import Semaphore from '@/views/components/Operative/Semaphore';

export default {
  mixins: [operativePageMixin, loadingDataMixin, computedFinancialDataMixin],
  components: {
    BFormCheckbox,
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    OperativeTableSectionTitle: () => import('../../../components/Operative/OperativeTableSectionTitle'),
    OperativeTable: () => import('../../../components/Operative/OperativeTable'),
    OperativeTableBodyHeader: () => import('../../../components/Operative/OperativeTableBodyHeader'),
    OperativeTableBodyRow: () => import('../../../components/Operative/OperativeTableBodyRow'),
    OperativeTableEmptyBodyRow: () => import('../../../components/Operative/OperativeTableEmptyBodyRow'),
    Semaphore,
  },
  filters: {
    money: formatMoney,
    alarm: formatAlertFilter,
    round: formatRoundFilter,
    category: formatCompanyCategory,
  },
  data () {
    return {
      crisiImpresaData: null,
      DSCRsignificant: true,
      companyCategory: undefined,
    };
  },
  computed: {
    monthsTableHeadings () {
      return this.convertToMonthsHeading(this.crisiImpresaData);
    },
    monthsTableRows () {
      return this.convertToRowGroupAutomatically(this.crisiImpresaData);
    },
  },
  methods: {
    retrieveData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.getCrisiImpresa(this.company?.id)
        .then(res => {
          this.crisiImpresaData = res?.data?.months || [];
          this.companyCategory = res?.data?.category || undefined;
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
  },
  watch: {
    company () {
      this.retrieveData();
    },
  },
};

</script>

<style lang="scss">

.page-operative-crisi-impresa {
  .operative-table-body-header {
    .operative-table-value-column-header {
      text-align: left;
    }
  }
}

</style>
